import { render, staticRenderFns } from "./AddPacker.vue?vue&type=template&id=123e1182"
import script from "./AddPacker.vue?vue&type=script&lang=js"
export * from "./AddPacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports